// src/pages/item/components/AddonItem/AddonItem.tsx
import React from "react";
import { MdAdd, MdDelete, MdRemove } from "react-icons/md";
import { useTheme } from "../../../../common/hooks/useTheme";
import { SaleItemInterface } from "../../../../common/types/types";

import styles from "./AddonItem.module.scss";
import { getImageUri } from "../../../../common/utils/functions/getImageUri";
import { ItemCardHeader } from "../../../../common/components/itemCardHeader/ItemCardHeader";
import { useDisplayPrice } from "../../../../common/hooks/useDisplayPrice";

type Props = {
  item: SaleItemInterface;
  quantity?: number;
  onAdd?: () => void;
  onIncrease?: () => void;
  onDecrease?: () => void;
  onRemove?: () => void;
};

export const AddonItem = ({
  item,
  quantity = 0,
  onAdd,
  onIncrease,
  onDecrease,
  onRemove,
}: Props) => {
  const { theme } = useTheme();
  const getPrice = useDisplayPrice();

  const imageUrl = item.files[0] ? `${getImageUri()}${item.files[0]}` : null;
  const price = getPrice(item.prices) ?? "Нет цены";

  const handleDecreasePress = () => {
    if (quantity === 1 && onRemove) {
      onRemove();
    } else if (onDecrease) {
      onDecrease();
    }
  };

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <div
        className={styles.imageContainer}
        style={{ backgroundColor: theme.card }}
      >
        {imageUrl ? (
          <img className={styles.image} src={imageUrl} alt={item.name} />
        ) : (
          <div className={styles.placeholder}>
            <MdAdd size={48} color={`${theme.textSecondary}80`} />
          </div>
        )}
      </div>

      <div className={styles.content}>
        <ItemCardHeader name={item.name || ""} price={price} small />

        {quantity === 0 ? (
          <button className={styles.addButton} onClick={onAdd}>
            <span className={styles.addButtonText}>Добавить</span>
          </button>
        ) : (
          <div
            className={styles.quantityContainer}
            style={{ backgroundColor: theme.card }}
          >
            <button
              className={styles.quantityButton}
              onClick={handleDecreasePress}
            >
              {quantity === 1 ? (
                <MdDelete size={12} color={theme.danger} />
              ) : (
                <MdRemove size={12} color={theme.primary} />
              )}
            </button>

            <div className={styles.quantityDisplay}>
              <span
                className={styles.quantityText}
                style={{ color: theme.text }}
              >
                {quantity}
              </span>
            </div>

            <button className={styles.quantityButton} onClick={onIncrease}>
              <MdAdd size={12} color={theme.success} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
